var juniper = {
  all_option: function(){ 

    $('.show_artist_list').on('click', function(){
      $(this).hide();
      $(this).closest('.facets__list').find('.facets__item').removeClass('hide_item');
    })

    $('.absd__btn').on('click', function(){
       $(this).toggleClass('active');
      var id = $(this).data('id');
      $('.absd_cover_img[data-id="'+id+'"]').toggleClass('active');
       
    });
 
    $( ".nav_list" ).mouseenter(function() {
       $(this).find('.mega_menu_box').slideDown('900').addClass('active');
    }).mouseleave(function() {
      $(this).find('.mega_menu_box').removeClass('active');
      $(this).find('.mega_menu_box').hide(); 
    });
    
     var $lgzm =  $('.lgzm_slider');
    
    $('.light_zoom').on('click', function(){
      var zooom = $(this).data('zoom');      
      $('.light_zoom_box').show();
      
      if(!$lgzm.hasClass('slick-slider'))
       popup_slider();
       
      $lgzm.slick('slickGoTo', zooom);
    });
    $('.lgzm_bg, .lgzm_close').on('click', function(){
      $('.light_zoom_box').hide();
    });
    
    function popup_slider(){
      $lgzm.slick({
        dots: true,
        infinite: true,
        speed: 500,
        arrows: true,
        slidesToShow: 1,
        adaptiveHeight: true,
        autoplay: false
      });
    }
    
    
    $('.iclst_menu_heading').on('click', function(){
      $(this).toggleClass('active');
      $(this).next('.iclst_menu_list').slideToggle().toggleClass('active');
    }); 
    
    
    
    
    
    /*
    setTimeout(function(){ 
      $('.slider_recommend').slick({
        dots: false,
        infinite: false,
        speed: 300,
        autoplay: false,
        slidesToShow: 1,
        variableWidth: true,
        arrow:true
      }); 
    },500);
    */
    
    var $slider = $('.oversized_slider');
    
    $slider.slick({
        dots: false,
        infinite: true,
        speed: 1500,
        autoplaySpeed: 4000,
        slidesToShow: 1, 
        autoplay: false
      });
      $slider.on('afterChange', function(event, slick, currentSlide, nextSlide){
        //console.log(slick.slideCount);
        var s = currentSlide+1;
        $('.ovsz_count').html('<span>'+s +'/'+slick.slideCount+'</span>');
      });
    
   
     
    
      $('.sldwmg_slider').slick({
        dots: false,
        infinite: true,
        speed: 1500,
        autoplaySpeed: 4000,
        slidesToShow: 1,
        adaptiveHeight: true,
        pauseOnHover: false,
        autoplay: true
      });
    
     $('.testimonial_box').slick({
        dots: true,
        infinite: true,
        speed: 800,
        slidesToShow: 1,
        adaptiveHeight: true,
        arrows: false,
         fade: true,
         autoplaySpeed:1000,
        autoplay: true
      });
    
    
    /*
       $('.bnvt_slider').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        arrows: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              arrows: false
            }
          },
          {
            breakpoint: 680,
            settings: {
              slidesToShow: 1 
            }
          } 
        ]
      });
    */
    
    
    $('.hmsl_box').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 5,
       slidesToScroll: 2,
        arrows: true,
        autoplay: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              arrows: false
            }
          },
          {
            breakpoint: 680,
            settings: {
              slidesToShow: 1 
            }
          } 
        ]
      });
    
    $('.hmpd_slider').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        arrows: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2 
            }
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1 
            }
          } 
        ] 
      });
    
    $('.home_logo_slider').slick({
      dots: false,
      infinite: true,
      speed: 3000,
      autoplay: true,
      autoplaySpeed: 0, 
      cssEase: "linear",
      variableWidth: true
    });
    
        
    $('.pdsld_slider').slick({
      dots: true,
      infinite: true,
      speed: 300,
      autoplay: false,
      slidesToShow: 1,
      arrows: false,
      adaptiveHeight: true
    });
    
     $('.pd_product_list').slick({
      dots: false,
      infinite: true,
      speed: 300,
      autoplay: false,
      slidesToShow: 3,
      arrows: true,
       responsive: [
         {
           breakpoint: 1024,
           settings: {
             slidesToShow: 2,
             slidesToScroll: 2,
             arrows: false
           }
         },
         {
           breakpoint: 680,
           settings: {
             slidesToShow: 1,
             slidesToScroll: 1 
           }
         } 
       ]  
    });
    
    /*
    $('.absd_slider').slick({
      dots: false,
      infinite: true,
      speed: 300,
      autoplay: false,
      slidesToShow: 1,
      arrows: true,
      adaptiveHeight: true,
       responsive: [
         {
           breakpoint: 768,
           settings: 'unslick'
         }  
       ]
    });
    */
    
    
    
    
    
    $('.hmtbcl_tab .tab_nav').on('click', function(){
      $('.hmtbcl_tab .tab_nav').removeClass('active');
      $(this).addClass('active');
      var id = $(this).data('id');
      
      $('.hmtbcl_accounting .hmtbcl_item').removeClass('active');
      $('.hmtbcl_accounting .hmtbcl_item[data-id="'+id+'"]').addClass('active');
    });
	
    
    $('.accoundin_heading').on('click', function(){
      $(this).toggleClass('active');
      $(this).next('.accoundin_description').slideToggle();
    });
    
    $('.acd_heading').on('click', function(){
      if(!$(this).hasClass('active')){
          $('.acd_heading').removeClass('active');
          $('.acd_description').hide();
      }
      
      $(this).toggleClass('active');
      $(this).next('.acd_description').slideToggle();
    });
    
    
    $('.footer-block__heading').on('click', function(){
      $(this).toggleClass('active');
      $(this).next('.footer-block__details-content').slideToggle();
    });
    
    

    /*$('.blog-listing').on('click', function(){
      $(this).toggleClass('active');
      $(this).children('.filter-li').slideToggle();
    });*/
    
    
    
    
    $('.mbnv_updown').on('click', function(e){
      e.preventDefault();
      $(this).closest('.mbnv_childlink').find('.mbnv_three').slideToggle();
      $(this).closest('.mbnv_childlink').toggleClass('active');
      
    });
    
    $('.mbnv_primary').on('click', function(){
      $('.mbnv_primary, .mbnv_item').removeClass('active');
      $(this).addClass('active');
      
      var id = $(this).data('id');
      $('.mbnv_item[data-id="'+id+'"]').addClass('active');
        
    });
    
  },
  combo_products: function(){
    
     var  product_number1 = null, combo1 = null,
          product_number2 = null, combo2 = null,
      	  product_number3 = null, combo3 = null,
          select_img = 0;
    
    $('.combo_option li').on('click', function(){
      
      
      $(this).closest('.combo_option').find('li').removeClass('active');
      $(this).addClass('active');
      
      $('button[name="add"]').attr('disabled', true);
      var option1=null, option2 = null, option3 = null;
          product_number1 = null, combo1 = null,
          product_number2 = null, combo2 = null,
      	  product_number3 = null, combo3 = null;
      
      $('.combo__new .product-form__input_new').each(function(index){
        var value = $.trim($(this).find('li.active').html());
        if(index == 0){
          option1 = value;
           
          product_number1 = $(this).find('li.active').data('id');
          combo1 = $(this).find('li.active').data('comb');
        }else if( index == 1){
          option2 = value;
          
          product_number2 = $(this).find('li.active').data('id');
          combo2 = $(this).find('li.active').data('comb');
        }else{
          option3 = value;
          
          product_number1 = $(this).find('li.active').data('id');
          combo1 = $(this).find('li.active').data('comb');
        } 
      });
     
      var selected_product = [];
      selected_product = select_product();
       
      
      $(selected_product).each(function(index, item){ 
        if(item.option1 == option1 && item.option2 == option2 && item.option3 == option3){
          $('.combo_select_value').attr('data-id', item.id);
          //console.log(item.price);
          
          // price 
          var price = item.price/100;
          $('.product__info-wrapper .price').html('$'+price+' USA');
          $('button[name="add"]').removeAttr('disabled');
          
          
          // image
          var img = '';
          if(select_img == 2){
            img = item.featured_image.src;
          }
          if(img !=''){
            $('.combo_select_img').html('<img src="'+img+'"/>').show();            
          }else{
            $('.combo_select_img').hide();    
          }
            
        } 
      });
      
      
      
      // hide product 
      var select_id = $(this).closest('.combo_option').data('val');
      var id = $(this).data('id');
      console.log(select_id);
      console.log(id);
      if(select_id == '1'){
         $('.combo_option[data-val="2"] li').hide();
        $('.combo_option[data-val="2"] li[data-id="'+id+'"]').css('display','inline-block');
      }
       
    });
    
    
    function select_product(){
      var selected_product = [];
       
      if(product_number3 == null){
         
        if(product_number1 == product_number2 && product_number2 == '1'){
          selected_product = normal;
          select_img = 1;
        }else if(product_number1 == product_number2 && product_number2 == '2'){
          selected_product = combo;
          select_img = 2;
        }else if( product_number1 != product_number2 ){
          
          if( combo1 == '1' || combo2 == '1'){
              if( combo1 == '1' && product_number2 == '2'){
                selected_product = combo
                select_img = 2;
              }else{
                 selected_product = normal;
                select_img = 1;
              }
          }
        }
        
      }else if(product_number2 == null){
      }else{ 
        
      }
      return selected_product; 
    }
    
    
    $('.combo_products_btn').on('click', function(e){
     	e.preventDefault();
      	var variant_id = $('.combo_select_value').attr('data-id'); 
          console.log(variant_id);
           $.ajax({
            type: 'POST', 
            url: '/cart/add.js',
            dataType: 'json', 
            data: 'quantity=1&id=' + variant_id,
             success: function(cart){
               window.location.href = '/cart';
             },
             error: function(res){
               console.log(res);             
             }
         }); 
      
    });
    
    
  },
  slider_button: function () {
    
    $('.slider_arrow').on('click', function() {
        var slider_width = $('.slider__slide').width();
        var item = $(this).data('size');
        var left_scroll = $('.slider-mobile-gutter ul').offset().left;
       $('.slider-mobile-gutter ul').animate({
          scrollLeft: slider_width
        }, '100');
       
    });
  } 
}
 
$(function(){
  juniper.all_option();
  juniper.slider_button();
  // juniper.combo_products();
});

$(window).scroll(function(){
   var scroll = $(window).scrollTop();
  if(scroll > 50){
     $('body').addClass('header_active');
  }else{
     $('body').removeClass('header_active');
  }
  
})


$(document).ready(function(){

      var list = $(".blog-articles .blog-articles__article");
      var numToShow = 6;
      var button = $(".load-more > div");
      var numInList = list.length;
      list.hide();
      if (numInList > numToShow) {
        button.show();
      }
      list.slice(0, numToShow).show();

      button.click(function(){
          var showing = list.filter(':visible').length;
          list.slice(showing - 1, showing + numToShow).fadeIn();
          var nowShowing = list.filter(':visible').length;
          if (nowShowing >= numInList) {
            button.hide();
          }
      });

});


  $("body").on("click", ".sub-accordion .acc-head", function(){
    $(this).next().slideToggle();
    $(this).toggleClass("active");
  });



















function sortMap(map) {
  try {
    map.forEach(function(valueList, key, map) {
      map.get(key).sort();
    });
  } catch(err){
  }
}

function updateList(option, updatedList) {
  try {
    var selectedValue = $(option).children("option:selected").val();
    var index = -1;

    // remove previous list
    $(option).find('option').remove();

    //update list with new values
    for (var i=0; i<updatedList.length; i++) {
      $(option).append($('<option>', { 
        value: updatedList[i],
        text : updatedList[i] 
      }));

      if (updatedList[i] == selectedValue) {
        index = i;
      }
    }
    //update previous selected value	
    if (index != -1) {
      $(option).val(updatedList[index]).change(); 
    } else if (updatedList[0]){
      $(option).val(updatedList[0]).change();
    }
  } catch(err){
  }
}

function updateListByMap(options, map) {
  try {
    var selectedValue1 = $(options[0]).children("option:selected").val();
    map.forEach(function(valueList, key, map) {
      if (key == selectedValue1) {
        updateList(options[1], valueList);
      }
    });
    //remove option-2 values on empty map
    if (map.size == 0) {
      $(options[1]).find('option').remove();
    }
  } catch(err){
  }
}

function updateListByMap1(options, map1) {
  try {
    var selectedValue1 = $(options[0]).children("option:selected").val();
    var selectedValue2 = $(options[1]).children("option:selected").val();
    var variant = selectedValue1+" / "+selectedValue2;
    map1.forEach(function(valueList, key, map) {
      if (key == variant) {
        updateList(options[2], valueList);
      }
    });
    //remove option-3 values on empty map
    if (map1.size == 0) {
      $(options[2]).find('option').remove();
    }
  } catch(err) {
  }
}

function removeImages(colorSelector) {
  try{
    var colorOptions = $(colorSelector).find('option');
    var imageOptions = $('.product-single__thumbnails-product-template').find('li');
    if (imageOptions.length != colorOptions.length) {
      // hide previous images
      $(imageOptions).hide();
      
      //show availabe variants images
      for (var l=0; l<colorOptions.length; l++) {
      	var colorName = $(colorOptions[l]).val();
		$("#"+colorName).show();
      }
      
    }
  } catch(err){
    console.log(err);
  }
}

$( document ).ready(function() {
  
  if( typeof product_variants_available != "undefined" && typeof product_options_count != "undefined") {
    var $addToCartForm = $('form[action="/cart/add"]');
       
     
    if (window.MutationObserver && $addToCartForm.length) {
     
      if (typeof observer === 'object' && typeof observer.disconnect === 'function') {
        observer.disconnect();
      }
      var config = { childList: true, subtree: true };
      var observer = new MutationObserver(function() {
        try{
          var options = $('.single-option-selector');
          
          if (product_options_count == 1 && options[0].length != product_variants_available.length) {
            updateList(options[0], product_variants_available);
            
          } else if (product_options_count == 2 || product_options_count == 3) {
            var map = new Map();
            var map1 = new Map();
            var list = [];
            // initialize map & list with values
            for (var i=0; i<product_variants_available.length; i++) {
              var variant = product_variants_available[i].split("/");
              var key = variant[0].trim();
              var value = variant[1].trim();
              if(map.has(key)) {
                if (map.get(key).includes(value) == false) {
                  map.get(key).push(value);
                }
              } else {
                map.set(key, [value]);
                list.push(key);
              }	
            }
            //sort map values
            if (product_options_count == 3) {
              sortMap(map);
            }
            //initialize map1 if there are three options
            if (product_options_count == 3) {
              // initialize map1 with values
              for (var i=0; i<product_variants_available.length; i++) {
                var variant = product_variants_available[i].split("/");
                var key = variant[0].trim() +" / "+ variant[1].trim();
                var value = variant[2].trim();
                if(map1.has(key)) {
                  map1.get(key).push(value);
                } else {
                  map1.set(key, [value]);
                }	
              }
            }
            //update option-1
            updateList(options[0], list);
            //update option-2
            updateListByMap(options, map);
            //update option-3 based on option count
            if (product_options_count == 3) {
              updateListByMap1(options, map1);
            }
            //add event on option-1 change
            $(options[0]).change(function () {
              updateListByMap(options, map);
              if (product_options_count == 3) {
                updateListByMap1(options, map1);
              }
            });
            //add event on option-2 change
            if (product_options_count == 3) {
              $(options[1]).change(function () {
                updateListByMap1(options, map1);
              });
            }
          }
          // remove the images of not available variants
          var selectors = $('.selector-wrapper');
          var colorSelectorIndex = -1;
          for (var k=0; k<selectors.length; k++) {
          	var label = $(selectors[k]).find("label").text();
            if (label.trim().toLowerCase().includes("color")) {
            	colorSelectorIndex=k;
            }
          }
          if (colorSelectorIndex!=-1) {
          	removeImages(options[colorSelectorIndex]);
          }
        } catch(err){
        }
        observer.disconnect();
      });
      observer.observe($addToCartForm[0], config);
      $('.single-option-selector').trigger('change');
    }
  }
});